import axios from 'axios'

const app_api = axios.create({
  baseURL:
    process.env.REACT_APP_BACKEND_URL ||
    "https://api.practice-exams.nrichlearning.com.au/api/v1",
});

export default app_api
